import { render, staticRenderFns } from "./AccessControlSystem.vue?vue&type=template&id=72c26716&scoped=true&"
import script from "./AccessControlSystem.vue?vue&type=script&lang=js&"
export * from "./AccessControlSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c26716",
  null
  
)

export default component.exports